import {
  FaHome,
  FaUser,
  FaFolderOpen,
  FaEnvelopeOpen,
  FaBriefcase,
  FaGraduationCap,
  FaCode,
} from 'react-icons/fa';
import { FiFileText, FiUser, FiExternalLink } from 'react-icons/fi';

import Work1 from './assets/project-1.png';
import Work2 from './assets/project-2.png';
import Work3 from './assets/project-3.png';
import Work4 from './assets/project-4.jpg';
import Work5 from './assets/project-5.jpg';
import Work6 from './assets/project-6.jpg';

import Theme1 from './assets/purple.png';
import Theme2 from './assets/red.png';
import Theme3 from './assets/blueviolet.png';
import Theme4 from './assets/blue.png';
import Theme5 from './assets/goldenrod.png';
import Theme6 from './assets/magenta.png';
import Theme7 from './assets/yellowgreen.png';
import Theme8 from './assets/orange.png';
import Theme9 from './assets/green.png';
import Theme10 from './assets/yellow.png';

export const links = [
  {
    id: 1,
    name: 'Home',
    icon: <FaHome className='nav__icon' />,
    path: '/',
  },

  {
    id: 2,
    name: 'About',
    icon: <FaUser className='nav__icon' />,
    path: '/about',
  },

  {
    id: 3,
    name: 'Portfolio',
    icon: <FaFolderOpen className='nav__icon' />,
    path: '/portfolio',
  },

  {
    id: 4,
    name: 'Contact',
    icon: <FaEnvelopeOpen className='nav__icon' />,
    path: '/contact',
  },
];

export const personalInfo = [
  {
    id: 1,
    title: 'First Name : ',
    description: 'Harshit',
  },

  {
    id: 2,
    title: 'Last Name : ',
    description: 'Gupta',
  },

  {
    id: 3,
    title: 'Age : ',
    description: '21 Years',
  },

  {
    id: 4,
    title: 'Nationality : ',
    description: 'Indian',
  },

  {
    id: 5,
    title: 'Freelance : ',
    description: 'Available',
  },


  {
    id: 7,
    title: 'Phone : ',
    description: '7985403660',
  },

  {
    id: 8,
    title: 'Email : ',
    description: 'happyharshit11@gmail.com',
  },
  {
    id: 10,
    title: 'Langages : ',
    description: 'Hindi, English',
  },
];

export const stats = [
  {
    id: 1,
    no: '2+',
    title: 'Years of <br /> Experience',
  },

  {
    id: 2,
    no: '10+',
    title: 'Completed <br /> Projects',
  },

  {
    id: 3,
    no: '20+',
    title: 'Good <br /> Feedbacks',
  },
];

export const resume = [
  {
    id: 1,
    category: "experience",
    icon: <FaBriefcase />,
    year: "Dec 2022 -Apr 2022",
    title: "Backend Developer <span> ChattEasy </span>",
    desc: "Worked as a Full-Stack developer in ChattEasy website( interaction with seniors and the same development field) for college students help.",
  },

  {
    id: 2,
    category: "experience",
    icon: <FaBriefcase />,
    year: "Aug 2022- Nov 2022",
    title: "Wipro Future Skills <span> Internship </span>",
    desc: "Learned about important technologies like IOT, Cyber Secuirity, etc.",
  },

  {
    id: 3,
    category: "experience",
    icon: <FaBriefcase />,
    year: "2005 - 2013",
    title: "Web Development <span> Internship </span>",
    desc: "Learned about HTML, CSS , ReactJs and made a College Survey website",
  },

  {
    id: 4,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2020-24",
    title: "Engineering Degree <span> KIET GROUP OF INNSTITUTIONS </span>",
    desc: "Computer Science with 8.03 CGPA (till Semester)",
  },

  {
    id: 5,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2017-18",
    title: "Intermediate  <span> Fatima School </span>",
    desc: "91%",
  },

  {
    id: 6,
    category: "education",
    icon: <FaGraduationCap />,
    year: "2015-2016",
    title: "High School <span> Fatima School </span>",
    desc: "10 CGPA",
  },
];

export const skills = [
  {
    id: 1,
    title: 'Html',
    percentage: '85',
  },

  {
    id: 2,
    title: 'Javascript',
    percentage: '60',
  },

  {
    id: 3,
    title: 'CSS',
    percentage: '70',
  },

  {
    id: 4,
    title: 'ReactJs',
    percentage: '66',
  },

  {
    id: 5,
    title: 'MaterialUI',
    percentage: '95',
  },

  {
    id: 6,
    title: 'NodeJs',
    percentage: '50',
  },

  {
    id: 7,
    title: 'MongoDB',
    percentage: '65',
  },

  {
    id: 8,
    title: 'ExpressJs',
    percentage: '45',
  },
];

export const portfolio = [
  {
    id: 1,
    img: Work1,
    title: 'Connect Easy',
    details: [
      {
        icon: <FiFileText />,
        title: 'Project : ',
        desc: 'ConnectEasy',
      },
      {
        icon: <FiUser />,
        title: 'Date : ',
        desc: 'Nov2022-Feb2023',
      },
      {
        icon: <FaCode />,
        title: 'Language : ',
        desc: 'MERN',
      },
      {
        icon: <FiExternalLink />,
        title: 'Preview : ',
        desc: 'www.dribble.com',
      },
    ],
  },

  {
    id: 2,
    img: Work2,
    title: 'Beauty Salon',
    details: [
      {
        icon: <FiFileText />,
        title: 'Project : ',
        desc: 'Beauty Salon',
      },
      {
        icon: <FiUser />,
        title: 'Date : ',
        desc: 'Sept2022',
      },
      {
        icon: <FaCode />,
        title: 'Language : ',
        desc: 'React JS, MaterialUI',
      },
      {
        icon: <FiExternalLink />,
        title: 'Preview : ',
        desc: 'www.dribble.com',
      },
    ],
  },

  {
    id: 3,
    img: Work3,
    title: 'ChattEasy',
    details: [
      {
        icon: <FiFileText />,
        title: 'Project : ',
        desc: 'ChattEasy',
      },
      {
        icon: <FiUser />,
        title: 'Date : ',
        desc: 'May2022-June2022',
      },
      {
        icon: <FaCode />,
        title: 'Language : ',
        desc: 'MERN, MaterialUI, Socket.io',
      },
      {
        icon: <FiExternalLink />,
        title: 'Preview : ',
        desc: 'www.dribble.com',
      },
    ],
  },

  {
    id: 4,
    img: Work4,
    title: 'Music Player',
    details: [
      {
        icon: <FiFileText />,
        title: 'Project : ',
        desc: 'Music Player',
      },
      {
        icon: <FiUser />,
        title: 'Date : ',
        desc: 'Feb2023-March2023',
      },
      {
        icon: <FaCode />,
        title: 'Language : ',
        desc: 'Doubly Linked List , JavaScript',
      },
      {
        icon: <FiExternalLink />,
        title: 'Preview : ',
        desc: 'www.dribble.com',
      },
    ],
  },

  {
    id: 5,
    img: Work5,
    title: 'Gym Website',
    details: [
      {
        title: 'Project : ',
        desc: 'Gym',
      },
      {
        title: 'Date : ',
        desc: '4 July2022-25July2022',
      },
      {
        title: 'Language : ',
        desc: 'React JS, API Fetching',
      },
      {
        title: 'Preview : ',
        desc: 'www.dribble.com',
      },
    ],
  },

];

export const themes = [
  {
    id: 1,
    img: Theme1,
    color: 'hsl(252, 35%, 51%)',
  },

  {
    id: 2,
    img: Theme2,
    color: 'hsl(4, 93%, 54%)',
  },

  {
    id: 3,
    img: Theme3,
    color: 'hsl(271, 76%, 53%)',
  },

  {
    id: 4,
    img: Theme4,
    color: 'hsl(225, 73%, 57%)',
  },

  {
    id: 5,
    img: Theme5,
    color: 'hsl(43, 74%, 49%)',
  },

  {
    id: 6,
    img: Theme6,
    color: 'hsl(339, 81%, 66%)',
  },

  {
    id: 7,
    img: Theme7,
    color: 'hsl(80, 61%, 50%)',
  },

  {
    id: 8,
    img: Theme8,
    color: 'hsl(19, 96%, 52%)',
  },

  {
    id: 9,
    img: Theme9,
    color: 'hsl(88, 65%, 43%)',
  },

  {
    id: 10,
    img: Theme10,
    color: 'hsl(42, 100%, 50%)',
  },
];
